import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import api , { API_BASE_URL } from "../../src/utils/api";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
};

const EditPropertyModal = ({ open, handleClose, propertyId, onSave }) => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (propertyId) {
      api.get(`/properties/${propertyId}`).then((res) => {
        setForm(res.data);
        setLoading(false);
      });
    }
  }, [propertyId]);

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async () => {
    try {
      await api.put(`/properties/${propertyId}`, form);
      onSave(); // refresh parent list
      handleClose();
    } catch (error) {
      console.error("Error updating property:", error);
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={modalStyle}>
        <Typography variant="h6" gutterBottom>
          Edit Property
        </Typography>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            <TextField
              fullWidth
              label="Street"
              name="street_1"
              value={form.street_1 || ""}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="City"
              name="city"
              value={form.city || ""}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="State"
              name="state"
              value={form.state || ""}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Postal Code"
              name="postal_code"
              value={form.postal_code || ""}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Neighborhood"
              name="neighborhood"
              value={form.neighborhood || ""}
              onChange={handleChange}
              sx={{ mb: 2 }}
            />
            {/* Add more fields if needed */}

            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={handleClose}>Cancel</Button>
              <Button variant="contained" onClick={handleSubmit}>
                Save
              </Button>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
};

export default EditPropertyModal;
